const axios = require('./axios').createInstance();

axios.interceptors.request.use(function (config) {
    config.headers['Client-Side'] = 'true';
    return config;
});

export function createAPI () {
  return {
    axios,
  };
}
